import { render } from "./PieMoney.vue?vue&type=template&id=6d55becd&scoped=true"
import script from "./PieMoney.vue?vue&type=script&lang=js"
export * from "./PieMoney.vue?vue&type=script&lang=js"

import "./PieMoney.vue?vue&type=style&index=0&id=6d55becd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d55becd"]])

export default __exports__